let wrongTips = {}
export default wrongTips = {
    'wrongPhone': 'Invalid phone number',
    'wrongSMSCode': 'Wrong SMS code',
    'wrongEmail': 'Wrong email address',
    'pwdNotSame': 'Two input password must be consistent',
    'wrongPwd': 'Password must be at least 8 characters and contain both letters and numbers',
    'notCheckAgreement': 'Please check the user privacy protection agreement',
    'notEmpty': 'Information must be filled'
}